import React from 'react';

const Dummy = (props) => {

    const noMargin = props.no_margin ? 'no-margin' : ''

    return (
        <div className={ `input-container dummy ${noMargin}` }>
            { props.children }
        </div>
    )
}

export default Dummy


// WEBPACK FOOTER //
// ./src/components/Form/Dummy.js